package com.parmartechnologies.business.feature.business.handler


import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.business.feature.business.repository.BusinessRepository


class BusinessHandler {

    val repository = BusinessRepository()
    var onCreateBusinessResponse: ((Business) -> Unit)? = null
    val myBusinessId: String
        get() {
            val business = shared().repository.myBusiness.value
            return business._id
        }
    val selectedBusinessId: String
        get() {
            val business = shared().repository.selectedBusiness.value
            return business._id
        }

    init {
        instance = this
    }

    companion object {
        private var instance: BusinessHandler? = null
        fun shared(): BusinessHandler {
            if (instance != null) {
                return instance as BusinessHandler
            } else {
                return BusinessHandler()
            }
        }
    }
}